module.exports = __webpack_public_path__ + "img/ph-icon.d56f00be.svg";